import {Component, Input, OnInit} from '@angular/core';
import {Znamka} from '../model/znamka';
import {HodnotenieDetailComponent} from '../hodnotenie-detail/hodnotenie-detail.component';
import {AppService} from '../app.service';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {PrerekvizityComponent} from '../prerekvizity/prerekvizity.component';
import { HttpClient } from '@angular/common/http';
import {Prerekvizita} from '../model/Prerekvizita';
import {RozvrhoveAkcieComponent} from '../rozvrhove-akcie/rozvrhove-akcie.component';
import {RozvrhovaAkcia} from '../model/RozvrhovaAkcia';
import {PredmetDetailComponent} from '../predmet-detail/predmet-detail.component';
import {Predmet} from '../model/predmet';
import {Predmety} from '../model/Predmety';
import { DetailAtributovPredmetuComponent } from '../detail-atributov-predmetu/detail-atributov-predmetu.component';
import {OpakovanyZapisComponent} from '../opakovany-zapis/opakovany-zapis.component';
import {Subscription} from 'rxjs';
import {Config} from '../model/Config';

@Component({
    selector: 'app-znamky-tabulka',
    templateUrl: './znamky-tabulka.component.html',
    styleUrls: ['./znamky-tabulka.component.css'],
    standalone: false
})
export class ZnamkyTabulkaComponent implements OnInit
{
  private aisRest = '/ais/rest/portal';

  @Input() data: Znamka[];

  private configLoader = new Subscription();

  protected config: Config;

  constructor(
    private appService: AppService,
    private dialogService: MatDialog,
    private translate: TranslateService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.configLoader = this.appService.configLoader
      .subscribe((config) => {
        this.config = config;
      });

    this.config = this.appService.getConfig();
  }

  openHodnotenieDetail(znamka: Znamka) {
    if (znamka.hodnotenieId || znamka.prihlaskaSsId) {
      this.dialogService.open(HodnotenieDetailComponent, {
        data: {
          znamka
        }
      });
    }
    else {
      this.appService.openErrorDialog(
        this.translate.instant(
          'Pre zvolený predmet nemáte zatiaľ zaevidované žiadne hodnotenie.'
        )
      );
    }
  }

  openPrerekvizity(znamka: Znamka) {
    this.http.get<Prerekvizita>('/ais/rest/portal/student-predmety/prerekvizity/' + znamka.id)
      .subscribe({
        next: (prerekvizita) => {
          this.dialogService.open(
            PrerekvizityComponent, {
              data: {
                znamka, prerekvizita
              }
            });
        },
        error: (error) => {
          console.error(error);
        }
    });
  }

  openOpakovanyZapis(predmet: Znamka) {
    if (predmet.nahradzam !== null) {
      const msg = this.translate.instant('Predmet už nahrádza nejaký predmet.');
      this.appService.openErrorDialog(msg);
      return;
    }

    if (predmet.idOpakovanyPredm > 0) {
      const msg = this.translate.instant('Predmet je už opakovaným zápisom.');
      this.appService.openErrorDialog(msg);
      return;
    }

    this.dialogService.open(
      OpakovanyZapisComponent, {
        minWidth: '400px',
        data: {
          predmet
        }
      });
  }

  openDetailAtributovPredmetu(predmet: Znamka) {
    if (this.dialogService.openDialogs.length === 0) {
      this.dialogService.open(
        DetailAtributovPredmetuComponent, {
          data: {
            predmet
          }
        });
    }
  }

  openRozvrhoveAkcie(predmet: Znamka)
  {
    this.http.get<RozvrhovaAkcia[]>('/ais/rest/portal/student-predmety/rozvrhove-akcie/' + predmet.id)
      .subscribe({
          next: (akcie) => {
            console.log('predmet: ' + predmet);
            console.log('akcie: ' + akcie);
            // const vyskaDialogu = akcie.length > 3 ? '93%' : '63%';
            if (this.dialogService.openDialogs.length === 0) {
                  this.dialogService.open(
                      RozvrhoveAkcieComponent, {
                          // height: vyskaDialogu,
                          data: {
                              predmet, akcie
                          }
                      });
              }
          },
          error: (error) => {
              console.error(error);
          }
    });
  }



  delete(predmet: Znamka) {
    const message = this.translate.instant('Naozaj odobrať predmet') + ' "' + predmet.predmetNazov + '" ' + this.translate.instant('zo zápisného listu?');

    this.appService.openConfirmDialog(message)
      .afterClosed().subscribe(
      (res) => {
        if (res === 'OK') {
          this.http.delete<Predmety>(
            '/ais/rest/portal/student-predmety/predmet-zapisneho-listu/' + predmet.id,
          )
            .subscribe({
              next: (predmety) => {
                this.appService.setPredmety(predmety);
                this.appService.openSnackBar(
                  this.translate.instant('Predmet bol odstránený.')
                );
              },
              error: (error) => {
                this.appService.openErrorDialog(error.error.message);
              }
          });
        }
      }
    );
  }

  openPredmetDetail(znamka: Znamka) {

    this.http.get<Predmet>('/ais/rest/portal/student-predmety/predmet/' + znamka.id)
      .subscribe({
        next: (predmet) => {
          this.dialogService.open(
            PredmetDetailComponent, {
                height: '90%',
              data: {
                predmet
              }
            });
          },
        error: (error) => {
          console.error(error);
        }
    });

  }

  onRozvrhOdhlasit(znamka: Znamka) {

    if (znamka.rozvrh === null) {
      this.appService.openErrorDialog(this.translate.instant('Nie ste prihlásený na žiadnu rozvrhovú akciu.'));
      return;
    }

    this.http.post<Predmety>(
      '/ais/rest/portal/student-predmety/rozvrh-odhlasit/' + znamka.id, []
    )
      .subscribe({
        next: (predmety) => {
          this.appService.setPredmety(predmety);
          this.appService.openSnackBar(
            this.translate.instant('Boli ste odhlásený z rozvrhu.')
          );
        },
        error: (error) => {
          this.appService.openErrorDialog(error.error.message);
        }
    });

  }

  zrusNahradu(znamka: Znamka) {
    this.appService.openConfirmDialog(
      this.translate.instant('Skutočne chcete odstrániť náhradu (opakovaný zápis) predmetu?')
    )
      .afterClosed()
      .subscribe(
        (res) => {
          if (res === 'OK') {
            this.http.delete(
              this.aisRest + '/student/opakovany-zapis/' + znamka.id,
            )
              .subscribe({
                next: () => {
                  this.appService.refreshPredmety();
                  this.appService.openSnackBar(
                    this.translate.instant('Náhrada (opakovaný zápis) predmetu bol odstránená.')
                  );
                },
                error: (error) => {
                  this.appService.openErrorDialog(error.error.message);
                }
              });
          }
        }
      );
  }
}
